<template>
    <div class="custom-simple-select">
        <div>
            <div @click="open=true" @blur="open=false">
                <div>
                    <p class="mb-0">
                        <b v-if="selected!=null">
                            <span>{{selected}}</span>
                        </b>
                        <b v-else>{{def ? def : placeholder}}</b>
                    </p>
                </div>
            </div>
            <transition name="dropdown">
                <div class="dropdown-list" v-show="open">
                    <div v-for="(item, index) in list" :key="index" :value="item" @click="onClick(item)">
                        <span>{{item}}</span>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CustomSimpleSelect',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    def: {},
    list: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      selected: null,
      open: false
    }
  },
  methods: {
    onClick: function (item) {
      this.$emit('change', item)
      this.open = false
      this.selected = item
    }
  },
  created () {
    this.selected = this.def
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/CustomSimpleSelect.vue